export default Object.freeze({
  INITIAL: 'Inicial',
  REVISION: 'Revisión',
  AMENDMENT: 'Enmienda',
});
